import { call, delay, put, takeEvery } from "redux-saga/effects";

import { actions } from "./slice";
import { AxiosResponse } from "axios";
import { post, uploadImg } from "../../../../utils/request";
import CatchBlockFunction from "../../../hooks/CatchBlockFunction";
import { toast } from "sonner";

export function* uploadDocumentRequest(action: {
  payload: { fileName: string; callback: any };
}) {
  try {
    const response: AxiosResponse = yield call(
      post,
      `admin/product/signed-url`,
      {
        fileName: action.payload.fileName,
      }
    );
    if (!response.status) {
      toast.error(response.data.message);
    }
    yield call(
      action?.payload?.callback(
        response.data.data.signedUrl,
        response.data.data.fileNameWithPrefix
      )
    );
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* multiUploadDocumentRequest(action: {
  payload: { fileNames: string[]; callback: any };
}) {
  try {
    const response: AxiosResponse = yield call(
      post,
      `admin/product/multi-signed-url`,
      {
        fileNames: action.payload.fileNames,
      }
    );
    if (!response.status) {
      toast.error(response.data.message);
    }
    console.log("response.data.data",response.data.data);
    
    yield call(
      action?.payload?.callback(
        response.data.data.map((item: any) => item.signedUrl),
        response.data.data.map((item: any) => item.fileNameWithPrefix)
      )
    );
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* UploadImageRequest(action: {
  payload: { data: any; signedUrl: string; result: any; callback: any };
}) {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(
      uploadImg,
      action.payload.signedUrl,
      action.payload.data,
      action.payload.result
    );
    if (!response.status) {
      toast.error(response.data.message);
    }
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* FileRepoSaga() {
  yield takeEvery(actions.getSignedMultiUrl, multiUploadDocumentRequest);
  yield takeEvery(actions.getSignedUrl, uploadDocumentRequest);
  yield takeEvery(actions.UploadImage, UploadImageRequest);
}
